import styled from 'styled-components';
import { Col } from 'antd';
import { Theme } from '@routific/hive';

export const COLUMN_WIDTHS = {
  name: '150px',
  routes: '40px',
  familiarity: '65px',
  speed: '56px',
} as const;

export const NumberOfRoutesCol = styled(Col)`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: ${Theme.Spacing.lgSpacing};
  width: ${COLUMN_WIDTHS.routes};
  overflow: visible;

  > div {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }
`;

export const FamiliarityCol = styled(Col)`
  flex: none;
  margin-left: ${Theme.Spacing.lgSpacing};
  display: inline-flex;
  align-items: center;
  gap: 1px;
  width: ${COLUMN_WIDTHS.familiarity};
`;

export const SpeedCol = styled(Col)`
  flex: none;
  margin-left: ${Theme.Spacing.mdSpacing};
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  min-width: ${COLUMN_WIDTHS.speed};
`;
